<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="dynamicShaping"
      :items="dynamicShaping"
      :fields="dynamicShapingFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="selectedDynamicShaping"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      selectedDynamicShaping: {
        isEdit: false
      },
      dynamicShapingFields: [
        {key: 'service_id', label: this.$i18n.t('Service ID'), sortable: true},
        {key: 'service_name', label: this.$i18n.t('Service name'), sortable: true},
        {key: 'comment', label: this.$i18n.t('Comment'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedDynamicShaping = {
        isEdit: false,
        service_id: 0,
        flags: 0
      }
      this.$root.$emit('bv::show::modal', 'modalEditDynamicShapingSettings', '#btnShow')
    },
    editItem (item) {
      this.selectedDynamicShaping = JSON.parse(JSON.stringify(item))
      this.selectedDynamicShaping.isEdit = true
      this.$root.$emit('bv::show::modal', 'modalEditDynamicShapingSettings', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Dynamic shaping"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_DYNAMIC_SHAPING', item.service_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_DYNAMIC_SHAPING_SERVICES')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    dynamicShaping () {
      return this.$store.getters['Settings/DYNAMIC_SHAPING_SERVICES']
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_DYNAMIC_SHAPING_SERVICES')
    this.$store.dispatch('Tariffing/GET_SERVICES')
    this.$store.dispatch('Tariffing/GET_TIME_RANGE')
    this.$store.dispatch('Tariffing/GET_TRAFFIC_CLASSES_LIST')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/system/dynamicShaping/main.vue